import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/** Lista/query e dashboard: datas em DD/MM/YYYY. */
export function parseDdMmYyyy(dateStr) {
    if (!dateStr || typeof dateStr !== 'string') return null;
    const d = dayjs(dateStr.trim(), 'DD/MM/YYYY', true);
    return d.isValid() ? d : null;
}

/** POST despesa (`date`) e PUT status (`payment_date`): YYYY-MM-DD. */
export function toIsoYyyyMmDd(dayjsValue) {
    return dayjsValue && dayjsValue.isValid() ? dayjsValue.format('YYYY-MM-DD') : '';
}

/** `date_created` na listagem (`GET /transactions/query`): DD/MM/YYYY → YYYY-MM-DD para formulário / PUT. */
export function listDateCreatedToIso(dateStr) {
    const d = parseDdMmYyyy(dateStr);
    return d ? d.format('YYYY-MM-DD') : '';
}

/**
 * Converte datas vindas da listagem/query (DD/MM/YYYY, YYYY-MM-DD ou ISO com hora)
 * para YYYY-MM-DD usado em `<input type="date">` e no PUT.
 */
export function transactionListDateToIso(dateStr) {
    if (dateStr == null || dateStr === '') return '';
    const trimmed = String(dateStr).trim();
    if (!trimmed) return '';

    const br = parseDdMmYyyy(trimmed);
    if (br) return br.format('YYYY-MM-DD');

    const isoDay = dayjs(trimmed, 'YYYY-MM-DD', true);
    if (isoDay.isValid()) return isoDay.format('YYYY-MM-DD');

    const parsed = dayjs(trimmed);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
}

const EDITABLE_EXPENSE_STATUSES = new Set(['pendente', 'pending', 'vencido']);

/** Despesas editáveis via `PUT /transactions/{id}` (conforme API). */
export function isEditableExpenseStatus(status) {
    if (status == null || status === '') return false;
    return EDITABLE_EXPENSE_STATUSES.has(String(status).toLowerCase().trim());
}
